import Swiper from 'swiper';

window.addEventListener('load', function(event) {

  // Gallery slider
  const gallerySliderContainers = document.querySelectorAll('.js-gallery-slider');

  if (gallerySliderContainers.length) {
    gallerySliderContainers.forEach((sliderGalleryContainer) => {

      const gallery = sliderGalleryContainer.querySelector('.swiper-container');
      const gallerySlides = sliderGalleryContainer.querySelectorAll('.swiper-slide');
      const galleryNav = sliderGalleryContainer.querySelector('.gallery-slider__nav');

      if (gallerySlides.length > 3) {
        const gallerySliderInstance = new Swiper(gallery, {
          slidesPerView: 3,
          spaceBetween: 30,
          // loop: true,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: sliderGalleryContainer.querySelector('.swiper-pagination'),
            clickable: false,
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
              return `<span class="${currentClass}"></span>
                        /
                      <span class="${totalClass}"></span>`
            }
          },
          navigation: {
            nextEl: sliderGalleryContainer.querySelector('.swiper-button-next'),
            prevEl: sliderGalleryContainer.querySelector('.swiper-button-prev')
          },
          breakpoints: {
            640: {
              slidesPerView: 1
            },
            1024: {
              slidesPerView: 2
            }
          }
        });
      } else {
        galleryNav.classList.add('visually-hidden');
        sliderGalleryContainer.classList.add('no-swiper');
      }
    });
  }


  // Team slider
  const teamSliderContainers = document.querySelectorAll('.js-gallery-slider');

  if (teamSliderContainers.length) {
    teamSliderContainers.forEach((sliderTeamContainer) => {

      const team = sliderTeamContainer.querySelector('.swiper-container');
      const teamSlides = sliderTeamContainer.querySelectorAll('.swiper-slide');
      const teamNav = sliderTeamContainer.querySelector('.gallery-slider__nav');

      if (teamSlides.length > 3) {
        const teamSliderInstance = new Swiper(team, {
          slidesPerView: 4,
          spaceBetween: 30,
          // loop: true,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: sliderTeamContainer.querySelector('.swiper-pagination'),
            clickable: false,
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
              return `<span class="${currentClass}"></span>
                        /
                      <span class="${totalClass}"></span>`
            }
          },
          navigation: {
            nextEl: sliderTeamContainer.querySelector('.swiper-button-next'),
            prevEl: sliderTeamContainer.querySelector('.swiper-button-prev')
          },
          breakpoints: {
            640: {
              slidesPerView: 1
            },
            1024: {
              slidesPerView: 2
            }
          }
        });
      } else {
        teamNav.classList.add('visually-hidden');
        sliderTeamContainer.classList.add('no-swiper');
      }
    });
  }

  // Diaporama slider
  const diaporamaSliderContainers = document.querySelectorAll('.js-diaporama-slider');

  if (diaporamaSliderContainers.length) {
    diaporamaSliderContainers.forEach((sliderDiaporamaContainer) => {

      const diaporama = sliderDiaporamaContainer.querySelector('.swiper-container');
      const diaporamaSlides = sliderDiaporamaContainer.querySelectorAll('.swiper-slide');
      const diaporamaNav = sliderDiaporamaContainer.querySelector('.diaporama-slider__nav');

      if (diaporamaSlides.length > 1) {
        const diaporamaSliderInstance = new Swiper(diaporama, {
          slidesPerView: 1,
          shortSwipes: false,
          longSwipesRatio: 0.2,
          longSwipesMs: 100,
          loop: true,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: sliderDiaporamaContainer.querySelector('.swiper-pagination'),
            clickable: false,
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
              return `<span class="${currentClass}"></span>
                        /
                      <span class="${totalClass}"></span>`
            }
          },
          navigation: {
            nextEl: sliderDiaporamaContainer.querySelector('.swiper-button-next'),
            prevEl: sliderDiaporamaContainer.querySelector('.swiper-button-prev')
          }
        });
      } else {
        diaporamaNav.classList.add('visually-hidden');
      }
    });
  }

});
